import * as React from "react"

function useOutsideAlerter(ref, cb) {
	React.useEffect(() => {
		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				cb(event)
			}
		}

		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside)
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside)
		}
	}, [cb, ref])
}

export default useOutsideAlerter
